const spotPagePath = (_id: string, slug: string) => `/surf-report/${slug}/${_id}`;

export default spotPagePath;
